import { FulfilmentStatus } from '../core/state/order/order.types';
import {
  ORDER_STATUS_FIRST_STEP_POLL_DELAY,
  ORDER_STATUS_POLL_DELAY,
} from './constants';

export const getOrderStatusPollDelay = (
  orderStatus: FulfilmentStatus | undefined,
): number => {
  if (orderStatus && !orderStatus.IsError) {
    if (orderStatus.StatusPosition === 0) {
      return ORDER_STATUS_FIRST_STEP_POLL_DELAY;
    }
    if (orderStatus.StatusPosition < orderStatus.TotalStatuses) {
      return ORDER_STATUS_POLL_DELAY;
    }
  }
  return null;
};
